import * as React from 'react';

import { EPromoType } from '../../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';
import { IBankSchema } from '../../../repositories/newbuilding-card/entities/promo/BankSchema';
import { BankIcon } from '../components/BankIcon/BankIcon';
import {
  ActionIcon,
  DiscountIcon,
  MaternalCapitalIcon,
  MilitaryMortgageIcon,
  MortgageIcon,
} from '../components/PromoIcons';

export function getPromoIcon(type: EPromoType, bank?: IBankSchema | null): React.ReactElement {
  switch (type) {
    case EPromoType.Discount:
      return <DiscountIcon />;
    case EPromoType.Mortgage:
    case EPromoType.CianMortgage:
      return <MortgageIcon />;
    case EPromoType.Bonus:
      return <ActionIcon />;
    case EPromoType.MilitaryMortgage:
      return <MilitaryMortgageIcon />;
    case EPromoType.MaternalCapital:
      return <MaternalCapitalIcon />;
    case EPromoType.Bank: {
      return <BankIcon bank={bank} />;
    }
  }
}
